import React from 'react';
import Button, {StyleType} from 'patient-ping-remedy/packages/button';
import {router} from '@/router';
import ErrorPage from '@/components/pages/error_pages/ErrorPage';
import {ErrorCenter} from '@/components/pages/error_pages/ErrorPage.styles';

export default function SSOAccessDenied() {
  const rawMessage = (sessionStorage.getItem('sso_access_denied') || '{}');

  const response = JSON.parse(rawMessage);
  sessionStorage.removeItem('sso_access_denied');

  return (
    <ErrorPage title={response.title!}>
      <span>{response.message ? response.message : 'Please contact your system administrator.'}</span>
      <ErrorCenter>
        <Button onClick={() => router.navigate('/')} styleType={StyleType.SECONDARY}>
          Return to Login
        </Button>
      </ErrorCenter>
    </ErrorPage>
  );
}
